import React, { FC } from 'react';
import { Container } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import PageTitle from '../../../components/layout/pageTitle/PageTitle';
//import { RouteComponentProps } from 'react-router-dom';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Props {}

const PaymentOptionsPage: FC<Props> = () => {
  const intl = useIntl();

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <PageTitle title={intl.formatMessage({ id: 'navbar.settings.paymentOptions.title' })}></PageTitle>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default PaymentOptionsPage;
